import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TransactionRequestType } from '@bp-core/src/lib/proto/goal-transaction-enums.pb';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'operation-type-select',
  templateUrl: './operation-type-select.component.html',
  styleUrls: ['./operation-type-select.component.scss'],
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, FormsModule, ReactiveFormsModule, MatOptionModule],
})
export class OperationTypeSelectComponent implements OnInit, OnDestroy, OnChanges {
  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  historyValues: number[] = [-1];
  formControl = new UntypedFormControl(-1);
  options: { id: number; text: string }[] = [
    {
      id: -1,
      text: 'Todo',
    },
    {
      id: TransactionRequestType.Buy,
      text: 'Depósito',
    },

    {
      id: TransactionRequestType.Sale,
      text: 'Retiro',
    },

    {
      id: TransactionRequestType.TransferGoal,
      text: 'Transferencia entre metas',
    },
    {
      id: TransactionRequestType.ChangePortfolio,
      text: 'Cambio de portafolio',
    },
    {
      id: TransactionRequestType.Dividend,
      text: 'Dividendos',
    },
  ];
  @Input() initialValue?: number[] = [-1];
  @Output() valueChange = new EventEmitter<{ value: number[]; labels: string[] }>();
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialValue?.currentValue) {
      if (this.initialValue && this.initialValue.length > 0) {
        this.formControl.setValue(this.initialValue, { emitEvent: false });
        this.historyValues = this.initialValue;
      } else {
        this.formControl.setValue([-1], { emitEvent: false });
        this.historyValues = [-1];
      }
    }
  }
  ngOnInit() {
    if (this.initialValue && this.initialValue.length > 0) {
      this.formControl.setValue(this.initialValue, { emitEvent: false });
      this.historyValues = this.initialValue;
    } else {
      this.formControl.setValue([-1], { emitEvent: false });
      this.historyValues = [-1];
    }

    this.formControl.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((values: number[]) => {
        if (!values.length) {
          this.historyValues = [-1];
          this.formControl.setValue(['']);
        }

        const diff = this.differenceArray(values, this.historyValues);
        if (diff.length > 0) {
          if (diff[0] !== -1) {
            values = values.filter(x => x !== -1);
          } else {
            values = [-1];
          }
          this.historyValues = values;

          this.formControl.setValue(values, { emitEvent: false });
          this.valueChange.emit({
            value: values,
            labels: this.options.filter(x => values.includes(x.id) && x.id !== -1).map(x => x.text),
          });

          return;
        }
        // console.log('dateRange', value);
      });

    // this.setInitialValue();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.unsubscribe();
  }

  /**
   * Devuelve la diferencia entre dos arreglos bidireccionales
   *
   * @private
   * @param {string[]} array1
   * @param {string[]} array2
   * @return {*}  {string[]}
   * @memberof OperationTypeSelectComponent
   */
  private differenceArray(array1: number[], array2: number[]): number[] {
    const diff1 = array1.filter(x => !array2.includes(x));
    const diff2 = array2.filter(x => !array1.includes(x));
    return diff1.concat(diff2);
  }
}
